var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('jobs',{attrs:{"message":'Train job at',"jobs":_vm.jobs},on:{"refresh":_vm.loadJobs}}),_c('train-configurations',{attrs:{"filter_model_type":_vm.model_type,"show_train_button":true,"triggered_config_ids":_vm.triggered_config_ids},on:{"update_label":_vm.update_label,"start_train_job":_vm.start_train_job}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }